module.exports = __webpack_public_path__ + "img/AMEX_200x120.ed34c2f4.jpg";